import { Icons, Tag } from '@pankod/refine-antd'
import React from 'react'

import type { ApprovalStatus } from '@resources/pendaftaran-diklat/types'

const ApprovalStatus = (props: { status: ApprovalStatus }) => {
  const state: Record<
    ApprovalStatus,
    { color: string; icon: React.ReactNode; children: React.ReactNode }
  > = {
    ADMIN_APPROVED: {
      color: 'success',
      icon: <Icons.CheckCircleFilled />,
      children: 'Sudah Disetujui',
    },
    ADMIN_REJECTED: {
      color: 'error',
      icon: <Icons.CloseCircleFilled />,
      children: 'Pengajuan Ditolak',
    },
    PENDING: {
      color: 'warning',
      icon: <Icons.ClockCircleOutlined />,
      children: 'Menunggu Persetujuan',
    },
  }
  return <Tag {...state[props.status]} />
}

export default ApprovalStatus
